import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

// Envioronment
import { environment } from "../../../../environments/environment";

// Services
import { ExternalService } from 'src/app/Services/external.service';
import { CmsService } from 'src/app/Services/cms.service';

declare let gtag: Function; // For GA4

@Component({
    selector: 'app-horarios',
    templateUrl: './horarios.component.html',
    standalone: false
})
export class HorariosComponent implements OnInit {
  municipalities: any[] = [];

  home_content: string = 'linhas-home-page';
  homeInfo: any = {};

  routes: any[] = []

  selectedRoute: any = {
    'number': '',
    'name': ''
  }

  routeColor: string = '';
  routeId: string = '';

  route: any[] = []

  searchForm: FormGroup = new FormGroup({
    municipality: new FormControl('')
  });

  searchProcess: boolean = false;
  searching: boolean = false;


  // ---CMS---
  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;
  timetables_content: string = 'linhas-horario';
  timetablesInfo: any = {};

  constructor(
    private externalService: ExternalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private cmsService: CmsService,
    private translate: TranslateService,
    private title: Title,
    private http: HttpClient
) {
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['horarios']
      this.title.setTitle(pageTitle);
    })
  }

  ngOnInit() {
    this.getMunicipalities();
    this.onChanges();
    //this.getTimetablesContent();
  }

  getTimetablesContent(){
    this.cmsService.getContentList(this.timetables_content, this.language).subscribe(
      {
        next: data => {
          this.timetablesInfo = data['body']['data'];
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  onChanges(){
    this.searchForm.get('municipality')?.valueChanges.subscribe(
      val => {
        console.log('Municipality changed:', val);
        if (val != '') {
          this.listRoutesByMunicipality(val);
        } else {
          this.routes.splice(0)
        }

      }
    )
  }

  listRoutesByMunicipality(municipality: string){
    this.externalService.getRoutesByMunicipality(municipality).subscribe(
      {
        next: data => {
          this.routes.splice(0);

          data.forEach(item => {
            let route = {
              number: item['pCodCarOperador'],
              name: item['pDesignacao'],
              municipality: municipality,
              operator: item['pdesigOperador'],
              codeCIM: item['pCodCarCIM'],
              color: item['pColorHex'],
              display: `${item['pCodCarOperador']} - ${item['pDesignacao']}`
            }
            const opt = document.createElement("option");
            opt.value = route.number + ' - ' + route.name;

            this.routes.push(route);
          });
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    )
  }

  getMunicipalities(){
    this.externalService.getMunicipalities().subscribe(
      {
        next: data => {

          this.municipalities.splice(0)

          data.forEach(element => {
            let mun = {
              name: element['pDescricao'],
              code: element['pDescricao'],
              key: element['pKey'],
              region: element['pNUTIII']
            }

            this.municipalities.push(mun)
          });

          this.municipalities = this.municipalities.sort((a: any, b: any) => a.name.localeCompare(b.name, 'pt', { sensitivity: 'base' }) );
        },
        error: er => {
        this.router.navigate(['/500']);
        }
      })
  }

  getSchedulePdf(routeNumber: string){
    let fileUrl = environment.schedulesUrl + routeNumber + '.pdf';

    window.open(fileUrl, '_blank');
  }

  downloadPdf(routeNumber: string){
    let fileUrl = environment.schedulesUrl + routeNumber + '.pdf';

    this.http.get(fileUrl, { responseType: 'blob' }).subscribe((blob: any) => {
      // Create a link element
      const link = document.createElement('a');
      const commonUrl = window.URL.createObjectURL(blob);
      
      link.href = commonUrl;
      link.download =  routeNumber + '.pdf'; 
      link.click();

      const fullUrl = window.location.href; // Full URL
      const pagePath = window.location.pathname; // Path after domain

      gtag('event', 'file_download', {
        'file_name': routeNumber + '.pdf',
        'page_path': pagePath,
        'page_title': routeNumber + '.pdf',
        'full_url': fullUrl,
        'subdomain': 'website'
      });
      
      // Clean up
      window.URL.revokeObjectURL(commonUrl);
      link.remove();
  });
  }
}
